import { CalendarClock, XCircle } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { request } from "@/lib/api";

export function AppointmentActions({ booking, onSubmitted }) {
  const { token } = useAuth();
  const [requestType, setRequestType] = useState("");
  const [reason, setReason] = useState("");
  const [requestedDate, setRequestedDate] = useState("");
  const [requestedSlot, setRequestedSlot] = useState("09:00 – 09:30");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const minimumRescheduleDate = tomorrow.toISOString().slice(0, 10);

  if (["awaiting_payment", "cancelled", "report_ready"].includes(booking.status)) {
    return null;
  }

  async function submit(event) {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const result = await request(
        `/bookings/${booking.booking_id}/change-requests`,
        {
          method: "POST",
          body: JSON.stringify({
            request_type: requestType,
            reason,
            requested_date: requestType === "reschedule" ? requestedDate : null,
            requested_slot: requestType === "reschedule" ? requestedSlot : null,
          }),
        },
        token,
      );
      onSubmitted(result);
      setRequestType("");
      setReason("");
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="appointment-actions" data-testid={`appointment-actions-${booking.booking_id}`}>
      {!requestType && <div className="appointment-actions__choices"><button type="button" onClick={() => setRequestType("reschedule")} data-testid={`reschedule-${booking.booking_id}-button`}><CalendarClock size={16} />Reschedule</button><button type="button" onClick={() => setRequestType("cancel")} data-testid={`cancel-${booking.booking_id}-button`}><XCircle size={16} />Cancel</button></div>}
      {requestType && <form onSubmit={submit} className="appointment-actions__form" data-testid={`change-request-form-${booking.booking_id}`}><label htmlFor={`reason-${booking.booking_id}`}>{requestType === "cancel" ? "Why do you need to cancel?" : "Why do you need to reschedule?"}</label><textarea id={`reason-${booking.booking_id}`} value={reason} onChange={(event) => setReason(event.target.value)} required data-testid={`change-reason-${booking.booking_id}-input`} />{requestType === "reschedule" && <><label htmlFor={`new-date-${booking.booking_id}`}>Requested date</label><input id={`new-date-${booking.booking_id}`} type="date" min={minimumRescheduleDate} value={requestedDate} onChange={(event) => setRequestedDate(event.target.value)} required data-testid={`change-date-${booking.booking_id}-input`} /><label htmlFor={`new-slot-${booking.booking_id}`}>Requested slot</label><select id={`new-slot-${booking.booking_id}`} value={requestedSlot} onChange={(event) => setRequestedSlot(event.target.value)} data-testid={`change-slot-${booking.booking_id}-select`}><option>09:00 – 09:30</option><option>10:00 – 10:30</option><option>11:00 – 11:30</option><option>15:00 – 15:30</option></select></>}{error && <p className="form-error" role="alert" data-testid={`change-request-error-${booking.booking_id}`}>{error}</p>}<div className="appointment-actions__form-buttons"><Button type="button" variant="outline" onClick={() => setRequestType("")} data-testid={`close-change-request-${booking.booking_id}-button`}>Close</Button><Button type="submit" disabled={isSubmitting} data-testid={`submit-change-request-${booking.booking_id}-button`}>{isSubmitting ? "Sending…" : "Send to provider"}</Button></div></form>}
    </div>
  );
}